import React from 'react';

import {ReactTyped} from 'react-typed';
import { useNavigate } from "react-router-dom";

const Hero = () => {
    const navigate = useNavigate();

    return (
        <div className='text-white'>
            <div className='max-w-[800px] mt-[-96px] w-full h-screen mx-auto text-center flex flex-col justify-center'>
                <p className='text-[#00fd9a] font-bold p-2'>
                    BUILD BETTER. BUILD WITH ME.    
                </p>
                <h1 className='md:text-7xl sm:text-6xl text-4xl font-bold  md:py-6'>
                    Hi!
                 </h1>
                <div className='flex justify-center items-center '>
                    <p className='md:text-5xl sm:text-4xl text-xl font-bold'>I've worked with&nbsp;</p>
                    <ReactTyped className='md:text-5xl sm:text-4xl text-xl font-bold' strings={['React &#x1f58c;','Next &#x1f916;','Express &#x1f4aa;','FastAPI &#x1f3ce;','MySQL &#x1f4d8;','PostgreSQL &#x1f5c4;']} typeSpeed={180} backSpeed={180} loop/>
                </div>

                <p className='md:text-2xl text-xl font-bold text-gray-400 p-2'>I'm Ahmad Waseem. I can help make your ideas a reality.</p>
                <button
                onClick={(e)=> {
                    navigate('/contact');
                }}
                type='button' 
                className='transition bg-[#009d77]  w-[200px] rounded-md font-medium my-6 mx-auto py-3'
                 >
                Reach out
                </button>
            </div>
        </div>
    )
}

export default Hero;